import { type EffectCallback } from 'react';
import { useOnMount } from 'tradera/hooks/use-on-mount';

export const useOnHashUpdated = (handleHashChanged: EffectCallback) => {
    useOnMount(() => {
        handleHashChanged();
        window.addEventListener('hashchange', handleHashChanged);
        return () =>
            window.removeEventListener('hashchange', handleHashChanged);
    });
};
